'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useAuth } from '@/components/AuthProvider';
export const OFF_MARKET_PASSCODE = 'CKPMembers';
export const OFF_MARKET_PASSCODE_KEY = 'ckp-off-market-passcode';

/**
 * Returns whether the visitor has access to off-market listings
 * via either a logged-in account OR the shared member passcode.
 */
export function useOffMarketAccess() {
  const $ = _c(10);
  const {
    user,
    loading,
    signOut
  } = useAuth();
  const [passcodeUnlocked, setPasscodeUnlocked] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined" && sessionStorage.getItem(OFF_MARKET_PASSCODE_KEY) === "true") {
        setPasscodeUnlocked(true);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = input => {
      if (input.trim() === OFF_MARKET_PASSCODE) {
        sessionStorage.setItem(OFF_MARKET_PASSCODE_KEY, "true");
        setPasscodeUnlocked(true);
        return true;
      }
      return false;
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const unlockWithPasscode = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      sessionStorage.removeItem(OFF_MARKET_PASSCODE_KEY);
      setPasscodeUnlocked(false);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const lockPasscode = t3;
  const t4 = !!user || passcodeUnlocked;
  let t5;
  if ($[4] !== loading || $[5] !== passcodeUnlocked || $[6] !== signOut || $[7] !== t4 || $[8] !== user) {
    t5 = {
      user,
      loading,
      signOut,
      passcodeUnlocked,
      unlockWithPasscode,
      lockPasscode,
      hasAccess: t4
    };
    $[4] = loading;
    $[5] = passcodeUnlocked;
    $[6] = signOut;
    $[7] = t4;
    $[8] = user;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}